import { useAppDescriptions } from '../product-descriptions';

import { ProductCardEditionOption } from './common/edition-options';
import { ProductCard } from './common/product-card';
import { useProductCardData } from './common/use-product-card-data';

export const JpdProductCard = () => {
	const { iconUrl, description } = useAppDescriptions().jpd;
	return (
		<ProductCard
			{...useProductCardData('jpd')}
			title="Jira Product Discovery"
			iconUrl={iconUrl}
			description={description}
			unitType="creator"
			editions={JPD_EDITIONS}
		/>
	);
};

export const JPD_EDITIONS: ProductCardEditionOption[] = [
	{ value: 'free', label: 'Free' },
	{ value: 'standard', label: 'Standard' },
	{ value: 'premium', label: 'Premium' },
];
